import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AnyNotesPageModule } from 'src/app/shared/modules/ui/components/any-notes-page/any-notes-page.module';
import { MyCommonModule } from '../../shared/modules/my-common/my-common.module';
import { UiModule } from '../../shared/modules/ui/ui.module';
import { VehicleServiceListComponent } from './components/vehicle-service-list/vehicle-service-list.component';
import { VehicleServiceComponent } from './containers/vehicle-service/vehicle-service.component';
import { HelperService } from './services/helper.service';
import { VehicleServiceGridComponent } from './components/vehicle-service-grid/vehicle-service-grid.component';
import { VehicleServiceDetailsTabsComponent } from './components/vehicle-service-details-tabs/vehicle-service-details-tabs.component';
import { VehicleServiceAddFormComponent } from './components/vehicle-service-form/vehicle-service-form.component';
import { VehicleDetailsTabInvoicesComponent } from './components/vehicle-service-details-tab-invoices/vehicle-service-details-tab-invoices.component';
import { VehicleDetailsTabfleetManagerCommentsComponent } from './components/vehicle-service-details-tab-fleet-manager-comments/vehicle-service-details-tab-fleet-manager-comments.component';
import { VehicleDetailsTabServiceStatesComponent } from './components/vehicle-service-details-tab-service-states/vehicle-service-details-tab-service-states.component';
import { VehicleDetailsTabSchedulesComponent } from './components/vehicle-service-details-tab-schedules/vehicle-service-details-tab-schedules.component';
import { VehicleDetailsTabRequestsComponent } from './components/vehicle-service-details-tab-requests/vehicle-service-details-tab-requests.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, RouterModule, MyCommonModule, UiModule, AnyNotesPageModule],
  declarations: [
    VehicleServiceAddFormComponent,
    VehicleServiceComponent,
    VehicleServiceListComponent,
    VehicleServiceGridComponent,
    VehicleServiceDetailsTabsComponent,
    VehicleDetailsTabRequestsComponent,
    VehicleDetailsTabServiceStatesComponent,
    VehicleDetailsTabSchedulesComponent,
    VehicleDetailsTabInvoicesComponent,
    VehicleDetailsTabfleetManagerCommentsComponent,
  ],
  exports: [VehicleServiceComponent, VehicleServiceGridComponent, VehicleServiceDetailsTabsComponent],
  entryComponents: [VehicleServiceComponent, VehicleServiceAddFormComponent],
  providers: [HelperService],
})
export class VehicleServiceModule {}
